(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var pendingKeys = {};
    var discountPending = false;
    var mutationQueue = Promise.resolve();

    function enqueueMutation(mutation) {
      var result = mutationQueue.then(mutation, mutation);
      mutationQueue = result.catch(function () {});
      return result;
    }

    function getDrawer() {
      return document.querySelector('[data-cart-drawer]');
    }

    function setCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    }

    function hideNativeUpdateButtons() {
      document.querySelectorAll('[data-cart-native-update]').forEach(function (btn) {
        btn.hidden = true;
      });
    }

    function applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var current = document.getElementById('shopify-section-' + id);
        if (!current) return;
        var parsed = new DOMParser().parseFromString(sections[id], 'text/html');
        var next = parsed.getElementById('shopify-section-' + id);
        if (!next) return;

        // The cart-drawer <dialog> carries live, client-only state (is it
        // open, its native modal/focus-trap internals, scroll position)
        // that a wholesale node replacement would destroy - a stepper
        // click inside an open drawer would otherwise snap it shut the
        // instant the response lands, since a freshly-parsed <dialog>
        // never has its [open] state. Refresh only the panel's contents
        // in place instead, leaving the <dialog> element itself (and the
        // persistent announcer outside it, see layout/theme.liquid)
        // untouched. Every other section (e.g. the cart page) has no such
        // state, so a plain node swap is correct there.
        if (id === 'cart-drawer') {
          var currentPanel = current.querySelector('[data-cart-drawer-panel]');
          var nextPanel = next.querySelector('[data-cart-drawer-panel]');
          if (currentPanel && nextPanel) {
            currentPanel.innerHTML = nextPanel.innerHTML;
            return;
          }
        }

        current.replaceWith(next);
      });
      hideNativeUpdateButtons();
    }

    function announce(message) {
      var el = document.querySelector('[data-cart-announcer]');
      if (!el || !message) return;
      // Clear-then-set on a tick so a repeated identical message (e.g.
      // two failed attempts in a row) still gets announced - most screen
      // readers only fire on an actual text mutation.
      el.textContent = '';
      window.setTimeout(function () {
        el.textContent = message;
      }, 50);
    }

    function announceUpdated() {
      var el = document.querySelector('[data-cart-announcer]');
      announce(el && el.getAttribute('data-updated-label'));
    }

    function currentSectionIds() {
      var ids = ['cart-drawer'];
      var pageSection = document.querySelector('[data-cart-section-id]');
      if (pageSection) {
        var id = pageSection.getAttribute('data-cart-section-id');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      }
      return ids;
    }

    function setLineBusy(line, busy) {
      if (!line) return;
      line.setAttribute('aria-busy', busy ? 'true' : 'false');
      line.querySelectorAll('button, input').forEach(function (el) {
        el.disabled = busy;
      });
    }

    function showError(root, message) {
      var errorEl = root && root.querySelector('[data-cart-error]');
      if (!errorEl) return;
      errorEl.textContent = message || errorEl.getAttribute('data-generic-error') || 'Something went wrong. Please try again.';
      errorEl.hidden = false;
    }

    function hideErrors() {
      document.querySelectorAll('[data-cart-error]').forEach(function (el) {
        el.hidden = true;
      });
    }

    function findLine(key, wasInDrawer) {
      var root = wasInDrawer ? getDrawer() : document.querySelector('[data-cart-page]');
      if (!root) return null;
      var lines = root.querySelectorAll('[data-cart-line]');
      for (var index = 0; index < lines.length; index += 1) {
        if (lines[index].getAttribute('data-cart-line-key') === key) return lines[index];
      }
      return null;
    }

    function changeLine(key, quantity, line, focusAttr) {
      if (!key || pendingKeys[key]) return;
      pendingKeys[key] = true;
      hideErrors();
      setLineBusy(line, true);

      // Resolved once, up front, while `line` is still attached: which
      // surface (drawer vs cart page) this change actually came from. The
      // same line key exists in both surfaces' markup simultaneously, so
      // an unscoped post-swap query could focus/report into the wrong one.
      var wasInDrawer = line ? !!line.closest('[data-cart-drawer]') : true;

      var panel = document.querySelector('[data-cart-drawer-panel]');
      var scrollTop = panel ? panel.scrollTop : 0;

      function currentRoot() {
        return wasInDrawer ? getDrawer() : document.querySelector('[data-cart-page]');
      }

      var canUnlock = false;

      function restoreFocusAndScroll() {
        var panelNow = document.querySelector('[data-cart-drawer-panel]');
        if (panelNow) panelNow.scrollTop = scrollTop;

        var root = currentRoot();
        var target = null;
        if (focusAttr && root) {
          target = root.querySelector('[data-cart-line-key="' + key + '"] [' + focusAttr + ']');
        }
        if (!target && wasInDrawer) {
          var drawer = getDrawer();
          if (drawer && drawer.open) target = drawer.querySelector('[data-cart-drawer-close]');
        }
        if (target) target.focus();
      }

      return enqueueMutation(function () {
        var activeLine = findLine(key, wasInDrawer) || line;
        setLineBusy(activeLine, true);

        function recoverCartState() {
          // The request failed (e.g. requested quantity exceeds stock).
          // Only /cart/add.js, /cart/change.js, /cart/update.js and
          // /cart/clear.js support the Section Rendering API - plain GET
          // /cart.js does not return a `sections` payload at all - so an
          // empty /cart/update.js call (no actual updates) is used here
          // purely to re-sync the real cart state via a supported
          // endpoint. The recovery promise is returned so the mutation
          // stays locked until the authoritative state has been applied.
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates: {},
              sections: currentSectionIds().join(','),
              sections_url: window.location.pathname,
            }),
          })
            .then(function (response) {
              return response.json().then(function (data) {
                if (!response.ok) throw new Error(data.description || '');
                return data;
              });
            })
            .then(function (data) {
              applySections(data.sections);
              setCounts(data.item_count);
            });
        }

        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: currentSectionIds().join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) {
                var err = new Error(data.description || '');
                throw err;
              }
              return data;
            });
          })
          .then(function (data) {
            applySections(data.sections);
            setCounts(data.item_count);
            restoreFocusAndScroll();
            announceUpdated();
            canUnlock = true;
          })
          .catch(function (err) {
            return recoverCartState()
              .then(function () {
                canUnlock = true;
                setLineBusy(findLine(key, wasInDrawer) || activeLine, false);
                restoreFocusAndScroll();
                showError(currentRoot(), err && err.message);
                announce(err && err.message);
              })
              .catch(function () {
                // Keep the affected line locked when Shopify cannot return
                // authoritative state. Re-enabling it would allow a second
                // mutation to build on stale quantities and totals.
                setLineBusy(findLine(key, wasInDrawer) || activeLine, true);
                showError(currentRoot(), err && err.message);
                announce(err && err.message);
              });
          })
          .finally(function () {
            if (canUnlock) delete pendingKeys[key];
          });
      });
    }

    function applyDiscount(code, sourceEl) {
      if (!code || discountPending) return;
      discountPending = true;
      var wasInDrawer = !!sourceEl.closest('[data-cart-drawer]');
      hideErrors();

      return enqueueMutation(function () {
        var root = wasInDrawer ? getDrawer() : document.querySelector('[data-cart-page]');
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            discount: code,
            sections: currentSectionIds().join(','),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.description || '');
              return data;
            });
          })
          .then(function (data) {
            applySections(data.sections);
            setCounts(data.item_count);
            announceUpdated();
          })
          .catch(function (err) {
            showError(root, err && err.message);
            announce(err && err.message);
          });
      })
        .finally(function () {
          discountPending = false;
        });
    }

    function open() {
      var drawer = getDrawer();
      if (drawer && typeof drawer.showModal === 'function') drawer.showModal();
    }

    function close() {
      var drawer = getDrawer();
      if (drawer && drawer.open) drawer.close();
    }

    window.SEL = window.SEL || {};
    window.SEL.cart = {
      applySections: applySections,
      enqueueMutation: enqueueMutation,
      setCounts: setCounts,
      open: open,
      close: close,
    };

    document.addEventListener('click', function (event) {
      var drawer = getDrawer();

      var openTrigger = event.target.closest('[data-cart-drawer-open]');
      if (openTrigger && drawer) {
        // Let a modifier-click (new tab/window) or a non-primary button
        // navigate normally instead of hijacking it into the drawer.
        if (event.defaultPrevented || event.button === 1 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return;
        }
        event.preventDefault();
        drawer.showModal();
        return;
      }

      if (drawer) {
        var closeTrigger = event.target.closest('[data-cart-drawer-close]');
        if (closeTrigger) {
          drawer.close();
          return;
        }

        if (event.target === drawer && drawer.open) {
          var rect = drawer.getBoundingClientRect();
          var inside =
            event.clientX >= rect.left &&
            event.clientX <= rect.right &&
            event.clientY >= rect.top &&
            event.clientY <= rect.bottom;
          if (!inside) drawer.close();
          return;
        }
      }

      var line;
      var decreaseBtn = event.target.closest('[data-cart-qty-decrease]');
      if (decreaseBtn) {
        line = decreaseBtn.closest('[data-cart-line]');
        var decInput = line && line.querySelector('[data-cart-qty-input]');
        if (decInput) {
          changeLine(
            line.getAttribute('data-cart-line-key'),
            Math.max(0, (parseInt(decInput.value, 10) || 0) - 1),
            line,
            'data-cart-qty-decrease'
          );
        }
        return;
      }

      var increaseBtn = event.target.closest('[data-cart-qty-increase]');
      if (increaseBtn) {
        line = increaseBtn.closest('[data-cart-line]');
        var incInput = line && line.querySelector('[data-cart-qty-input]');
        if (incInput) {
          changeLine(
            line.getAttribute('data-cart-line-key'),
            (parseInt(incInput.value, 10) || 0) + 1,
            line,
            'data-cart-qty-increase'
          );
        }
        return;
      }

      var removeBtn = event.target.closest('[data-cart-remove]');
      if (removeBtn) {
        event.preventDefault();
        line = removeBtn.closest('[data-cart-line]');
        if (line) changeLine(line.getAttribute('data-cart-line-key'), 0, line);
        return;
      }

      // The cart page's discount apply button is a plain button (not its
      // own nested <form>) since it lives inside the page's outer cart
      // form tag, and HTML forms cannot nest.
      var pageApplyBtn = event.target.closest('[data-cart-discount-page-apply]');
      if (pageApplyBtn) {
        event.preventDefault();
        var pageInput = document.querySelector('[data-cart-discount-page-input]');
        var pageCode = pageInput ? pageInput.value.trim() : '';
        applyDiscount(pageCode, pageApplyBtn);
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-cart-discount-form]');
      if (!form) return;
      event.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var code = input ? input.value.trim() : '';
      applyDiscount(code, form);
    });

    function commitQtyInput(input) {
      var line = input.closest('[data-cart-line]');
      if (!line) return;
      var parsed = parseInt(input.value, 10);
      if (isNaN(parsed) || parsed < 0) {
        // Blank/invalid input must not be coerced to 0 (which would
        // delete the line) - restore the last known-good value instead.
        input.value = input.defaultValue;
        return;
      }
      changeLine(line.getAttribute('data-cart-line-key'), parsed, line, 'data-cart-qty-input');
    }

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-cart-qty-input]');
      if (!input) return;
      commitQtyInput(input);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      var input = event.target.closest('[data-cart-qty-input]');
      if (!input) return;
      // Prevent the keystroke from also triggering the form's native
      // submit (the hidden bulk-update button remains a valid submit
      // target for the form regardless of its `hidden` state).
      event.preventDefault();
      commitQtyInput(input);
    });

    // The native <dialog> 'close' event does not bubble, so this must be
    // registered on the capture phase to reach it via delegation.
    document.addEventListener(
      'close',
      function (event) {
        if (!event.target || !event.target.matches || !event.target.matches('[data-cart-drawer]')) return;
        hideErrors();
      },
      true
    );

    hideNativeUpdateButtons();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('[data-collection-sort-form]');
        if (form) form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    var localizationSelect = document.querySelector('[data-localization-select]');
    if (localizationSelect) {
      localizationSelect.addEventListener('change', function () {
        localizationSelect.form.submit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var toggle = document.querySelector('[data-header-menu-toggle]');
    var drawer = document.querySelector('[data-header-drawer]');
    if (!toggle || !drawer) return;

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      drawer.hidden = isOpen;
    });

    // Closing on navigation-away isn't needed (a link click unloads the
    // page), but resize past the mobile breakpoint should reset state so
    // the drawer doesn't reopen stuck if the viewport widens.
    var mql = window.matchMedia('(min-width: 780px)');
    function handleBreakpointChange(event) {
      if (event.matches) {
        toggle.setAttribute('aria-expanded', 'false');
        drawer.hidden = true;
      }
    }
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleBreakpointChange);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function () {
    // A role="alert" region present at page load (rather than mutated
    // after load) isn't reliably announced on its own - same fix as
    // snippets/waitlist-form.liquid's own submit-result handling.
    var errorEl = document.querySelector('[data-password-error]');
    if (errorEl) errorEl.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Description clamp/"Read more" toggle. Only shown at all when the
    // clamped description actually overflows two lines - a short
    // description that already fits gets no toggle button, rather than
    // a "Read more" that reveals nothing new.
    var description = document.querySelector('[data-description]');
    var toggle = document.querySelector('[data-description-toggle]');
    if (description && toggle) {
      description.classList.add('product-detail__description--clamped');
      if (description.scrollHeight > description.clientHeight + 1) {
        toggle.hidden = false;
        var label = toggle.querySelector('[data-description-toggle-label]');
        var moreText = label.textContent;
        var lessText = toggle.getAttribute('data-less-label') || moreText;
        toggle.addEventListener('click', function () {
          var isOpen = !description.classList.contains('product-detail__description--clamped');
          description.classList.toggle('product-detail__description--clamped', isOpen);
          label.textContent = isOpen ? moreText : lessText;
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-slideshow]').forEach(function (root) {
      var track = root.querySelector('[data-slideshow-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slideshow-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slideshow-dot]'));
      var prevBtn = root.querySelector('[data-slideshow-prev]');
      var nextBtn = root.querySelector('[data-slideshow-next]');
      if (!track || slides.length === 0) return;

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var current = 0;
      var autoplayTimer = null;

      function goTo(index, behavior) {
        var target = slides[(index + slides.length) % slides.length];
        track.scrollTo({ left: target.offsetLeft, behavior: reduceMotion ? 'auto' : (behavior || 'smooth') });
      }

      function setActive(index) {
        current = index;
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
      }

      // Tracks which slide is actually in view (e.g. after a manual swipe/
      // scroll, not just button clicks) so the dots never drift out of sync.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActive(slides.indexOf(entry.target));
              }
            });
          },
          { root: track, threshold: 0.6 }
        );
        slides.forEach(function (slide) {
          observer.observe(slide);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          goTo(i);
        });
      });

      var autoplayMs = root.getAttribute('data-slideshow-autoplay');
      if (autoplayMs && !reduceMotion && slides.length > 1) {
        function startAutoplay() {
          stopAutoplay();
          autoplayTimer = setInterval(function () {
            goTo(current + 1);
          }, parseInt(autoplayMs, 10));
        }
        function stopAutoplay() {
          if (autoplayTimer) clearInterval(autoplayTimer);
        }
        startAutoplay();
        // Pause on hover/focus so autoplay never fights a visitor who is
        // actively reading a slide or using the controls.
        root.addEventListener('mouseenter', stopAutoplay);
        root.addEventListener('mouseleave', startAutoplay);
        root.addEventListener('focusin', stopAutoplay);
        root.addEventListener('focusout', startAutoplay);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
